module.exports = __webpack_public_path__ + "media/cards/Apple-Pay-Mark-ae70497e.png";